var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            title: "Create a meeting push",
            visible: _vm.dialogVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            closed: _vm.onClosed,
          },
        },
        [
          _c("el-row", { attrs: { type: "flex", justify: "center" } }, [
            _c(
              "div",
              { staticStyle: { "padding-left": "20px" } },
              [
                _c("h3", { staticClass: "details-title" }, [
                  _vm._v("Step 1 Create Online Meeting"),
                ]),
                _c("MeetingStepOne", {
                  ref: "meetingStepOne",
                  on: { success: _vm.onSuccess },
                }),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "h3",
                  {
                    staticClass: "details-title",
                    staticStyle: { "margin-left": "30px" },
                  },
                  [_vm._v("Step 2 Create a push")]
                ),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "padding-lr",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.editMeetingFormRules,
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Greetings", prop: "greeting" } },
                      [
                        _c("el-input", {
                          staticClass: "greet-input",
                          attrs: {
                            maxlength: "20",
                            placeholder: "Please input greetings",
                          },
                          model: {
                            value: _vm.form.greeting,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "greeting", $$v)
                            },
                            expression: "form.greeting",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pushToMSL",
                        staticStyle: { "margin-bottom": "5px!important" },
                        attrs: { label: "Setting", prop: "pushToMSL" },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { disabled: _vm.disablePushToMSL },
                                model: {
                                  value: _vm.form.pushToMSL,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "pushToMSL", $$v)
                                  },
                                  expression: "form.pushToMSL",
                                },
                              },
                              [_vm._v("Push to Me")]
                            ),
                            _vm.disablePushToMSL
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "bind-wechat-link",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.bindWeChat()
                                      },
                                    },
                                  },
                                  [_vm._v(" Bind WeChat? ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "push-to-msl-msg",
                            attrs: { slot: "error" },
                            slot: "error",
                          },
                          [_vm._v(_vm._s(_vm.pushToMSLMsg))]
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "isWeComSend",
                        staticStyle: { "margin-bottom": "5px!important" },
                        attrs: { prop: "isWeComSend" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "checkbox-wrapper" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.form.isWeComSend,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "isWeComSend", $$v)
                                  },
                                  expression: "form.isWeComSend",
                                },
                              },
                              [_vm._v("WeCom Send")]
                            ),
                            _vm.form.isWeComSend
                              ? _c(
                                  "el-checkbox",
                                  {
                                    on: { change: _vm.onContactsOnlyChange },
                                    model: {
                                      value: _vm.form.contactsOnly,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "contactsOnly", $$v)
                                      },
                                      expression: "form.contactsOnly",
                                    },
                                  },
                                  [_vm._v("Contacts Only")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Tag" } },
                      [
                        _c("HcpTagSelect", {
                          model: {
                            value: _vm.selectedTagIds,
                            callback: function ($$v) {
                              _vm.selectedTagIds = $$v
                            },
                            expression: "selectedTagIds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "seIds", label: _vm.formItemLabel } },
                      [
                        _vm.isSupervisor || _vm.isMSL
                          ? _c(
                              "el-radio-group",
                              {
                                on: { input: _vm.changeSeType },
                                model: {
                                  value: _vm.seType,
                                  callback: function ($$v) {
                                    _vm.seType = $$v
                                  },
                                  expression: "seType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "All" } }, [
                                  _vm._v("All"),
                                ]),
                                _c("el-radio", { attrs: { label: "SE" } }, [
                                  _vm._v("SE"),
                                ]),
                                _c("el-radio", { attrs: { label: "CE" } }, [
                                  _vm._v("CE"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("SEMultipleSelect", {
                          attrs: {
                            showTips: true,
                            placeholder: _vm.selectPlaceholder,
                            options: _vm.seListByType,
                            showTag: false,
                            type: "push",
                          },
                          on: { "select-change": _vm.onSESelectChange },
                          model: {
                            value: _vm.form.seIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "seIds", $$v)
                            },
                            expression: "form.seIds",
                          },
                        }),
                        _c("div", { staticClass: "selected-hcp-count" }, [
                          _vm._v("Selected: "),
                          _c("strong", [_vm._v(_vm._s(_vm.form.seIds.length))]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Select Meeting", prop: "meetingId" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "Please select meeting",
                              "popper-class": "meeting-select",
                            },
                            on: { change: _vm.onMeetingSelectChange },
                            model: {
                              value: _vm.form.meetingId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "meetingId", $$v)
                              },
                              expression: "form.meetingId",
                            },
                          },
                          _vm._l(_vm.meetingTitleList, function (item, index) {
                            return _c(
                              "el-option",
                              {
                                key: index,
                                attrs: {
                                  label: item.Title,
                                  value: item.MeetingId,
                                },
                              },
                              [
                                _c("span", { staticStyle: { float: "left" } }, [
                                  _vm._v(_vm._s(item.Title)),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      color: "#8492a6",
                                      "font-size": "13px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.range))]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "request-type",
                        attrs: { prop: "meetingRequestType" },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.onRequestTypeChange },
                            model: {
                              value: _vm.form.meetingRequestType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "meetingRequestType", $$v)
                              },
                              expression: "form.meetingRequestType",
                            },
                          },
                          _vm._l(_vm.pushTypes, function (type) {
                            return _c(
                              "div",
                              { key: type.key },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    key: type.key,
                                    staticStyle: { "line-height": "32px" },
                                    attrs: { label: type.key },
                                  },
                                  [_vm._v(_vm._s(type.value))]
                                ),
                                _vm.form.meetingRequestType === type.key &&
                                type.key === 0
                                  ? [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please input reason",
                                        },
                                        model: {
                                          value: _vm.form.requestContent,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "requestContent",
                                              $$v
                                            )
                                          },
                                          expression: "form.requestContent",
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                                _vm.form.meetingRequestType === type.key &&
                                type.key === 1
                                  ? [
                                      _c(
                                        "el-row",
                                        {
                                          attrs: {
                                            type: "flex",
                                            align: "bottom",
                                            gutter: 20,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass:
                                                "interaction-date-time",
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "interactionDateTime",
                                                    label:
                                                      "Interaction date/time",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "datetime" },
                                                    [
                                                      _c("el-date-picker", {
                                                        attrs: {
                                                          type: "date",
                                                          format:
                                                            _vm.dateFormat,
                                                          "value-format":
                                                            _vm.dateFormat,
                                                          placeholder: "Date",
                                                          editable: false,
                                                        },
                                                        model: {
                                                          value: _vm.iDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.iDate = $$v
                                                          },
                                                          expression: "iDate",
                                                        },
                                                      }),
                                                      _c(
                                                        "el-select",
                                                        {
                                                          ref: "iTime",
                                                          refInFor: true,
                                                          staticClass:
                                                            "times-select",
                                                          attrs: {
                                                            clearable: "",
                                                            "allow-create": "",
                                                            filterable: "",
                                                            placeholder: "Time",
                                                          },
                                                          on: {
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.onTimeBulr(
                                                                $event,
                                                                "iTime"
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value: _vm.iTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.iTime = $$v
                                                            },
                                                            expression: "iTime",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-input__icon el-icon-time",
                                                            attrs: {
                                                              slot: "prefix",
                                                            },
                                                            slot: "prefix",
                                                          }),
                                                          _vm._l(
                                                            _vm.times,
                                                            function (item, i) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: i,
                                                                  attrs: {
                                                                    label:
                                                                      item.value,
                                                                    value:
                                                                      item.value,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { staticClass: "interaction-type" },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "interactionTypeId",
                                                    label: "Interaction type",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "Interaction type",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .interactionTypeId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "interactionTypeId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.interactionTypeId",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.interTypes,
                                                      function (t) {
                                                        return _c("el-option", {
                                                          key: t.key,
                                                          attrs: {
                                                            label: t.value,
                                                            value: t.key,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "Request Content" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: "3",
                                              maxlength: 200,
                                            },
                                            model: {
                                              value: _vm.form.requestContent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "requestContent",
                                                  $$v
                                                )
                                              },
                                              expression: "form.requestContent",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm.form.meetingRequestType === type.key &&
                                type.key === 6
                                  ? [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "Please input reason",
                                        },
                                        model: {
                                          value: _vm.form.requestContent,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "requestContent",
                                              $$v
                                            )
                                          },
                                          expression: "form.requestContent",
                                        },
                                      }),
                                      _c(
                                        "CheckboxGroup",
                                        {
                                          staticClass: "activity_options",
                                          model: {
                                            value: _vm.form.initActivities,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "initActivities",
                                                $$v
                                              )
                                            },
                                            expression: "form.initActivities",
                                          },
                                        },
                                        _vm._l(
                                          _vm.activityOptions,
                                          function (activity) {
                                            return _c(
                                              "Checkbox",
                                              {
                                                key: activity.optionId,
                                                attrs: {
                                                  label: activity.optionId,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      activity.optionValue
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "editor",
                        attrs: { label: "Content", prop: "paperContent" },
                      },
                      [
                        _c("TinymceEditor", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.visible,
                              expression: "visible",
                            },
                          ],
                          ref: "vTinymce",
                          attrs: { height: 300 },
                          on: { input: _vm.paperContentValidator },
                          model: {
                            value: _vm.form.paperContent,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "paperContent", $$v)
                            },
                            expression: "form.paperContent",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "footer", staticStyle: { "margin-top": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.previewing },
                        on: { click: _vm.onPreview },
                      },
                      [_vm._v(" " + _vm._s(_vm.previewLabel) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.actionDisabled,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSubmit(1)
                          },
                        },
                      },
                      [_vm._v(" Submit push ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.actionDisabled },
                        on: {
                          click: function ($event) {
                            return _vm.onSubmit(0)
                          },
                        },
                      },
                      [_vm._v(" Save Draft ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("QRCodeDialog", {
        attrs: { visible: _vm.qrcodeDialogVisible, data: _vm.previewUrl },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.previewUrl = $event
          },
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "custom-confirm-dialog",
          attrs: {
            title: "请确认推送的HCP",
            visible: _vm.customConfirmVisible,
            width: "500px",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.customConfirmVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "confirm-dialog-content" }, [
            _vm.confirmedContactsNames.length > 0
              ? _c("div", { staticClass: "confirm-section" }, [
                  _c("div", { staticClass: "confirm-title" }, [
                    _vm._v(
                      "已添加MSL企业微信联系人：" +
                        _vm._s(_vm.confirmedContactsNames)
                    ),
                  ]),
                  _c("div", { staticClass: "confirm-hint" }, [
                    _vm._v("(可推送至医生微信)"),
                  ]),
                ])
              : _vm._e(),
            _vm.unconfirmedContactsNames.length > 0 &&
            _vm.confirmedContactsNames.length > 0
              ? _c("div", { staticClass: "confirm-divider" })
              : _vm._e(),
            _vm.unconfirmedContactsNames.length > 0
              ? _c("div", { staticClass: "confirm-section" }, [
                  _c("div", { staticClass: "confirm-title" }, [
                    _vm._v(
                      "未添加MSL企业微信联系人： " +
                        _vm._s(_vm.unconfirmedContactsNames)
                    ),
                  ]),
                  _c("div", { staticClass: "confirm-hint" }, [
                    _vm._v("(不可推送至医生微信)"),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.customConfirmCancel } }, [
                _vm._v("Cancel"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customConfirmSubmit },
                },
                [_vm._v("Submit")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }